<template>
  <div v-if="!isLogin() && !isHome()" class="navigation">
    <router-link v-if="!isHome()" :to="$route.meta.backRoute" class="prev">
      <i class="icone icon-chevron-gauche"></i>
      {{ getTranslation($route.meta.back) }}
    </router-link>
    <LogoComponent v-if="!isHome()" />
    <!--    <router-link-->
    <!--      v-if="isHome()"-->
    <!--      :to="{ name: 'About', params: { type: 'about' } }"-->
    <!--      class="allAbout"-->
    <!--    >-->
    <!--      {{ $t("all_about_aixam") }}-->
    <!--    </router-link>-->
  </div>
</template>

<script>
import LogoComponent from "@/components/LogoComponent.vue";
import { getTranslation } from "@/services/translation-manager";

export default {
  name: "NavComponent",
  components: { LogoComponent },
  methods: {
    isHome() {
      return this.$route.name === "Home";
    },

    isLogin() {
      return this.$route.name === "Login";
    },

    getTranslation(id) {
      return getTranslation(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(135, 170, 209, 0.4);
  height: 75px;
  padding: 5px 0;
  z-index: 1000;
}

.prev,
.allAbout {
  position: absolute;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.55);
  background: none;
  border: none;
  color: $white;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 15px;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;

  .icone {
    font-size: 30px;
    margin-right: 10px;
    position: relative;
    top: -1px;
  }
}

.allAbout {
  font-style: italic;
  left: initial;
  right: 0;
}
</style>
